import { Viewer, Worker } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { imgUrl } from "../../Helpers/utils/Constant";
import { Box, Typography } from "@mui/material";
const PdfAndImageView = ({ file }: { file?: string | null }) => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const cleanFile = file?.split('?')[0] || '';
  const type = cleanFile.split('.').pop()?.toLowerCase();
  const fileFullUrl = file
    ? file.startsWith('http') || file.startsWith('blob:')
      ? file
      : file.startsWith('/')
      ? `${imgUrl}${file}`
      : `${imgUrl}/${file}`
    : '';

  return (
    <div style={{ padding: '0px 10px', maxWidth: '100%', overflow: 'hidden' }}>
      {file && type ? (
        <>
          {type === 'pdf' ? (
            <div style={{ width: '100%', maxWidth: '800px', margin: '0 auto' }}>
              <Worker workerUrl='https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.js'>
                <div
                  style={{
                    height: '550px',
                    maxHeight: '70vh',
                  }}
                >
                  <Viewer
                    fileUrl={fileFullUrl}
                    plugins={[defaultLayoutPluginInstance]}
                  />
                </div>
              </Worker>
            </div>
          ) : (
            <Box sx={{ textAlign: 'center' }}>
              <img
                src={fileFullUrl}
                alt='Document Preview'
                style={{
                  maxWidth: '100%',
                  maxHeight: '70vh',
                  height: 'auto',
                  objectFit: 'contain',
                  borderRadius: '6px',
                }}
              />
              <Box sx={{ mt: 1 }}>
                <a
                  href={fileFullUrl}
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{
                    display: 'inline-block',
                    padding: '6px 16px',
                    backgroundColor: '#0c4da2',
                    color: '#fff',
                    textDecoration: 'none',
                    borderRadius: '4px',
                    fontSize: '14px',
                    fontWeight: 500,
                  }}
                >
                  Download / View Full
                </a>
              </Box>
            </Box>
          )}
        </>
      ) : (
        <Typography py={2} px={2} textAlign={'center'} variant='h5'>
          No file found
        </Typography>
      )}
    </div>
  );
};

export default PdfAndImageView;
